import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutline from '@mui/icons-material/RemoveCircleOutline';

import ConfirmDialog from 'portal/src/components/common/ConfirmDialog';

const ConfirmChangeActiveDialog = ({
  isActive,
  isLoading,
  itemName = 'row',
  onClose,
  onConfirm,
  showDialog,
}: {
  isActive?: boolean;
  isLoading: boolean;
  itemName?: string;
  onClose: () => void;
  onConfirm: () => void;
  showDialog: boolean;
}) => {
  return (
    <ConfirmDialog
      open={showDialog}
      onClose={onClose}
      message={
        (isActive
          ? `Deactivating this ${itemName} will remove all associated data from reports. `
          : '') +
        'Are you sure you want to ' +
        (isActive ? 'deactivate ' : 'reactivate ') +
        `this ${itemName}?`
      }
      primaryButtonLabel={isActive ? 'Deactivate' : 'Reactivate'}
      onPrimaryButtonClicked={onConfirm}
      secondaryButtonLabel="Cancel"
      onSecondaryButtonClicked={onClose}
      primaryButtonColor={isActive ? 'error' : 'secondary'}
      renderElement={
        isActive ? (
          <RemoveCircleOutline sx={{ color: 'error.main' }} />
        ) : (
          <AddCircleOutlineIcon sx={{ color: 'success.main' }} />
        )
      }
      isLoading={isLoading}
    />
  );
};

export default ConfirmChangeActiveDialog;
